import React from 'react';
import {Bar} from 'react-chartjs-2';
import './Chart.css'
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'

const options = {
    responsive: true,
    maintainAspectRatio: false,

    legend: {
        display: true,
        position: 'bottom',
        labels: {boxWidth: 15, padding: 20}
    },
    tooltips: {
        mode: 'label'
    },
    elements: {
        line: {
            fill: false,
            borderWidth: 2,
        }
    },
    scales: {
        xAxes: [
            {
                barThickness: 6,
                // barPercentage: 1.0,
                categoryPercentage: 0.5,
                display: true,
                gridLines: {
                    display: false
                },
            }
        ],
        yAxes: [
            {
                type: 'linear',
                display: true,

                position: 'left',
                id: 'y-axis-1',
                gridLines: {
                    display: true
                },
                ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        if(parseInt(value, 10) >= 1000){
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        } else {
                            return value;
                        }
                    }
                }
            },
        ]
    }
};

const slice = (arr, length) => {
    var start = 1;
    if(length) {
        start = arr.length - length;
    }
    return arr.slice(start, arr.length)
};

const Chart = (props) => {
    const {data, periodLength, currency, strings} = props;

    let dataPerCurrency = [];
    let chartData = null;

    dataPerCurrency[currency] = {
        labels: [],
        sales: [],
        collections: [],
        differences: [],
        confirmed: [],
        balance_safebag: [],
        balance_recyclable: [],
        balance_manualdeposit: [],
        balance_overflow: []
    };

    let days = data[currency];

    for (let day in days) {
        dataPerCurrency[currency].labels.push(day.substring(8));
        dataPerCurrency[currency].sales.push( (days[day].salesProcessedAmount + days[day].salesUnprocessedAmount) / 100);
        dataPerCurrency[currency].collections.push((days[day].collectionAmount/100)*-1);
        dataPerCurrency[currency].differences.push((days[day].diffAmount/100)*-1);
        dataPerCurrency[currency].confirmed.push((days[day].confirmedAmount/100));
        dataPerCurrency[currency].balance_safebag.push(days[day].balanceSafebagAmount/100);
        dataPerCurrency[currency].balance_recyclable.push(days[day].balanceRecyclableAmount/100);
        dataPerCurrency[currency].balance_manualdeposit.push(days[day].balanceManualDepositAmount/100);
        dataPerCurrency[currency].balance_overflow.push(days[day].balanceOverflowAmount/100);
    }

    chartData = {
        labels: slice(dataPerCurrency[currency].labels, periodLength),
        datasets: [
            {
                type: 'bar',
                label: strings.Sales,
                data: slice(dataPerCurrency[currency].sales, periodLength),
                fill: false,
                backgroundColor: LoomisColors.darkGrey,
                borderColor: LoomisColors.darkGrey,
                hoverBackgroundColor: LoomisColors.darkGrey,
                hoverBorderColor: LoomisColors.darkGrey,
                borderWidth: 0,
                yAxisID: 'y-axis-1',

            },
            {
                type: 'bar',
                label: strings.Pickup,
                data: slice(dataPerCurrency[currency].collections, periodLength),
                fill: false,
                backgroundColor: LoomisColors.lightBlue,
                borderColor: LoomisColors.lightBlue,
                hoverBackgroundColor: LoomisColors.lightBlue,
                hoverBorderColor: LoomisColors.lightBlue,
                borderWidth: 0,
                yAxisID: 'y-axis-1',

            },
            {
                type: 'bar',
                label: strings.Confirmed,
                data: slice(dataPerCurrency[currency].confirmed, periodLength),
                fill: false,
                backgroundColor: LoomisColors.green,
                borderColor: LoomisColors.green,
                hoverBackgroundColor: LoomisColors.green,
                hoverBorderColor: LoomisColors.green,
                borderWidth: 0,
                yAxisID: 'y-axis-1',

            },
            {
                type: 'bar',
                label: strings.Difference,
                data: slice(dataPerCurrency[currency].differences, periodLength),
                fill: false,
                backgroundColor: LoomisColors.red,
                borderColor: LoomisColors.red,
                hoverBackgroundColor: LoomisColors.red,
                hoverBorderColor: LoomisColors.red,
                borderWidth: 0,
                yAxisID: 'y-axis-1',

            },
            {
                label: strings.SafebagBalance,
                type: 'line',
                data: slice(dataPerCurrency[currency].balance_safebag, periodLength),
                fill: false,
                borderColor: LoomisColors.black,
                backgroundColor: LoomisColors.black,
                pointBorderColor: LoomisColors.black,
                pointBackgroundColor: LoomisColors.black,
                pointHoverBackgroundColor: LoomisColors.black,
                pointHoverBorderColor: LoomisColors.black,
                borderWidth: 0,
                yAxisID: 'y-axis-1',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 20,
                pointHoverRadius: 3,
            },
            {
                label: strings.RecyclableBalance,
                type: 'line',
                data: slice(dataPerCurrency[currency].balance_recyclable, periodLength),
                fill: false,
                borderColor: LoomisColors.yellow,
                backgroundColor: LoomisColors.yellow,
                pointBorderColor: LoomisColors.yellow,
                pointBackgroundColor: LoomisColors.yellow,
                pointHoverBackgroundColor: LoomisColors.yellow,
                pointHoverBorderColor: LoomisColors.yellow,
                borderWidth: 0,
                yAxisID: 'y-axis-1',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 20,
                pointHoverRadius: 3,
            },
            {
                label: strings.ManualDepositBalance,
                type: 'line',
                data: slice(dataPerCurrency[currency].balance_manualdeposit, periodLength),
                fill: false,
                borderColor: LoomisColors.grey,
                backgroundColor: LoomisColors.grey,
                pointBorderColor: LoomisColors.grey,
                pointBackgroundColor: LoomisColors.grey,
                pointHoverBackgroundColor: LoomisColors.grey,
                pointHoverBorderColor: LoomisColors.grey,
                borderWidth: 0,
                yAxisID: 'y-axis-1',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 20,
                pointHoverRadius: 3,
            },
            {
                label: strings.OverflowBalance,
                type: 'line',
                data: slice(dataPerCurrency[currency].balance_overflow, periodLength),
                fill: false,
                borderColor: LoomisColors.lightGrey,
                backgroundColor: LoomisColors.lightGrey,
                pointBorderColor: LoomisColors.lightGrey,
                pointBackgroundColor: LoomisColors.lightGrey,
                pointHoverBackgroundColor: LoomisColors.lightGrey,
                pointHoverBorderColor: LoomisColors.lightGrey,
                borderWidth: 0,
                yAxisID: 'y-axis-1',
                lineTension: 0,
                pointRadius: 0,
                pointHitRadius: 20,
                pointHoverRadius: 3,
            }
        ]
    };


    return (
        <div className="ChartWrapper">
            <div className="ChartHeader">
                <FontIcon className="material-icons">equalizer</FontIcon>
                <div>{strings.SalesBalancesAndPickups} : {currency}</div>
            </div>
            <div className="Chart">
                {chartData !== null ? (
                    <Bar data={chartData} options={options}/>
                ) : strings.NoDataAvailable}
            </div>
        </div>
    );
};

export default translate('Chart')(Chart);



// WEBPACK FOOTER //
// ./src/components/chart/Chart.js